import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Packages from "./pages/Packages";
import Destination from "./pages/Destination";
import Booking from "./pages/Booking";
import Team from "./pages/Team";
import Testimonial from "./pages/Testimonial";
import Error from "./pages/Error";
import Contact from "./pages/Contact";

export default function App() {
  const [cookiesAccepted, setCookiesAccepted] = useState(() => {
    return localStorage.getItem("cookiesAccepted") === "true";
  });

  useEffect(() => {
    if (cookiesAccepted) {
      localStorage.setItem("cookiesAccepted", "true");
    }
  }, [cookiesAccepted]);

  const acceptCookies = () => {
    setCookiesAccepted(true);
  };

  const rejectCookies = () => {
    localStorage.setItem("cookiesAccepted", "false");
    setCookiesAccepted(false);
  };

  const openSettings = () => {
    alert("Çerez ayarları paneli eklenebilir.");
  };

  return (
    <div>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/destination" element={<Destination />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/team" element={<Team />} />
        <Route path="/testimonial" element={<Testimonial />} />
        <Route path="/error" element={<Error />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />

      {!cookiesAccepted && (
        <div id="cookie-overlay">
          <div id="cookie-banner">
            <div className="cookie-content">
              <h2 style={{ color: "white", marginBottom: "10px" }}>Gizliliğinize Önem Veriyoruz</h2>
              <p>Bu site, deneyiminizi geliştirmek için çerezler aracılığıyla verilerinizi toplar. Bu verileri, sosyal medya özellikleri sağlamak, içeriği kişiselleştirmek ve trafiğimizi analiz etmek için kullanıyoruz. Aşağıdaki "Tümünü Kabul Et" butonuna tıklayarak bu teknolojinin kullanımına izin vermiş olursunuz.</p>
            </div>
            <div className="cookie-buttons">
              <button className="accept" onClick={acceptCookies}>
                Tümünü kabul et
              </button>
              <button className="reject" onClick={rejectCookies}>
                Tümünü reddet
              </button>
              <button className="settings" onClick={openSettings}>
                Değişiklik yap
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}